var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-tree-view-rows"},[_c('RecycleScroller',{ref:"virtualList",staticStyle:{"height":"100%"},attrs:{"items":_vm.rows,"item-size":40,"key-field":"$id"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return _c('tree-view-row',{class:{
        'dp-tree-view-row--odd': index % 2 !== 0,
      },attrs:{"data":item,"columns":_vm.columns,"selection":_vm.selection,"locked":_vm.locked},on:{"expand":function () { return _vm.expandRow(item); },"contract":function () { return _vm.contractRow(item); },"select-device":function (ref) {
            var ev = ref.ev;
            var device = ref.device;

            return _vm.selectDevice({ ev: ev, device: device, index: index });
}}})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }